import React from 'react';

export const SmileyIcon = () => {
	return (
		<svg
			viewBox='0 0 24 24'
			height='24'
			width='24'
			preserveAspectRatio='xMidYMid meet'
			className='ekdr8vow dhq51u3o'
			version='1.1'
			x='0px'
			y='0px'
			enable-background='new 0 0 24 24'
			// xml:space='preserve'
		>
			<path
				fill='currentColor'
				d='M9.153,11.603c0.795,0,1.439-0.879,1.439-1.962S9.948,7.679,9.153,7.679 S7.714,8.558,7.714,9.641S8.358,11.603,9.153,11.603z M5.949,12.965c-0.026-0.307-0.131,5.218,6.063,5.551 c6.066-0.25,6.066-5.551,6.066-5.551C12,14.381,5.949,12.965,5.949,12.965z M17.312,14.073c0,0-0.669,1.959-5.051,1.959 c-3.505,0-5.388-1.164-5.607-1.959C6.654,14.073,12.566,15.128,17.312,14.073z M11.804,1.011c-6.195,0-10.826,5.022-10.826,11.217 s4.826,10.761,11.021,10.761S23.02,18.423,23.02,12.228C23.021,6.033,17.999,1.011,11.804,1.011z M12,21.354 c-5.273,0-9.381-3.886-9.381-9.159s3.942-9.548,9.215-9.548s9.548,4.275,9.548,9.548C21.381,17.467,17.273,21.354,12,21.354z  M15.108,11.603c0.795,0,1.439-0.879,1.439-1.962s-0.644-1.962-1.439-1.962s-1.439,0.879-1.439,1.962S14.313,11.603,15.108,11.603z'
			></path>
		</svg>
	);
};

export const FileIcon = () => {
	return (
		<svg
			viewBox='0 0 24 24'
			height='24'
			width='24'
			preserveAspectRatio='xMidYMid meet'
			className=''
			version='1.1'
			x='0px'
			y='0px'
			enable-background='new 0 0 24 24'
			// xml:space='preserve'
		>
			<path
				fill='currentColor'
				d='M1.816,15.556v0.002c0,1.502,0.584,2.912,1.646,3.972s2.472,1.647,3.974,1.647 c1.501,0,2.91-0.584,3.972-1.645l9.547-9.548c0.769-0.768,1.147-1.767,1.058-2.817c-0.079-0.968-0.548-1.927-1.319-2.698 c-1.594-1.592-4.068-1.711-5.517-0.262l-7.916,7.915c-0.881,0.881-0.792,2.25,0.214,3.261c0.959,0.958,2.423,1.053,3.263,0.215 c0,0,3.817-3.818,5.511-5.512c0.28-0.28,0.267-0.722,0.053-0.936c-0.08-0.08-0.164-0.164-0.244-0.244 c-0.191-0.191-0.567-0.349-0.957,0.04c-1.699,1.699-5.506,5.506-5.506,5.506c-0.18,0.18-0.635,0.127-0.976-0.214 c-0.098-0.097-0.576-0.613-0.213-0.973l7.915-7.917c0.818-0.817,2.267-0.699,3.23,0.262c0.5,0.501,0.802,1.1,0.849,1.685 c0.051,0.573-0.156,1.111-0.589,1.543l-9.547,9.549c-0.756,0.757-1.761,1.171-2.829,1.171c-1.07,0-2.074-0.417-2.83-1.173 c-0.755-0.755-1.172-1.759-1.172-2.828l0,0c0-1.071,0.415-2.076,1.172-2.83c0,0,5.322-5.324,7.209-7.211 c0.157-0.157,0.264-0.579,0.028-0.814c-0.137-0.137-0.21-0.21-0.342-0.342c-0.2-0.2-0.553-0.263-0.834,0.018 c-1.895,1.895-7.205,7.207-7.205,7.207C2.4,12.645,1.816,14.056,1.816,15.556z'
			></path>
		</svg>
	);
};

export const Home = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='28'
			height='28'
			viewBox='0 0 28 28'
			{...props}
		>
			<g data-name='Group 17915'>
				<path data-name='Path 9' d='M0 0h28v28H0z' fill='none' />
			</g>
			<g data-name='Group 17916'>
				<path
					data-name='Path 10'
					d='m13.333 5.917 7 5.25v10.5h-14v-10.5l7-5.25m0-2.917L4 10v14h18.667V10z'
					transform='translate(.667 .5)'
					fill={props.fill}
				/>
			</g>
		</svg>
	);
};

export const HomeFilled = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='28'
			height='28'
			viewBox='0 0 28 28'
		>
			<path data-name='Path 11' d='M0 0h28v28H0z' fill='none' />
			<path
				data-name='Path 12'
				d='M13.333 3 4 10v14h18.667V10z'
				transform='translate(.667 .5)'
				fill={props.fill}
			/>
		</svg>
	);
};

export const Chats = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='28'
			height='28'
			viewBox='0 0 28 28'
		>
			<path data-name='Path 15' d='M0 0h28v28H0z' fill='none' />
			<path
				data-name='Path 16'
				d='M17.167 4.333V12.5H5.7l-.688.688-.677.677V4.333h12.832M18.333 2H3.167A1.17 1.17 0 0 0 2 3.167V19.5l4.667-4.667h11.666a1.17 1.17 0 0 0 1.167-1.166v-10.5A1.17 1.17 0 0 0 18.333 2zm5.833 4.667h-2.333v10.5H6.667V19.5a1.17 1.17 0 0 0 1.167 1.167h12.833l4.667 4.667V7.833a1.17 1.17 0 0 0-1.167-1.166z'
				transform='translate(.333 .333)'
				fill={props.fill}
			/>
		</svg>
	);
};
export const GetinTouch = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='28'
			height='28'
			viewBox='0 0 28 28'
		>
			<path data-name='Path 15577' d='M0 0h28v28H0z' fill='none' />
			<path
				data-name='Path 15578'
				d='M22.833 17.583a13.254 13.254 0 0 1-4.165-.665 1.3 1.3 0 0 0-.362-.058 1.2 1.2 0 0 0-.828.338l-2.567 2.567a17.587 17.587 0 0 1-7.688-7.677L9.79 9.51a1.145 1.145 0 0 0 .292-1.178 13.254 13.254 0 0 1-.665-4.165A1.17 1.17 0 0 0 8.25 3H4.167A1.17 1.17 0 0 0 3 4.167 19.832 19.832 0 0 0 22.833 24 1.17 1.17 0 0 0 24 22.833V18.75a1.17 1.17 0 0 0-1.167-1.167zM5.368 5.333h1.75a15.47 15.47 0 0 0 .537 3.022l-1.4 1.412a17.487 17.487 0 0 1-.887-4.433zm16.3 16.3a17.385 17.385 0 0 1-4.433-.887l1.4-1.4a14.878 14.878 0 0 0 3.033.525z'
				transform='translate(.5 .5)'
				fill={props.fill}
			/>
			<path
				data-name='Path 15584'
				d='M24 6H14v7h10zm-1.429 2.8L19 11.25 15.429 8.8V7.4L19 9.85l3.571-2.45z'
				transform='translate(0 -2.5)'
				fill={props.fill}
			/>
		</svg>
	);
};

export const GetinTouchFilled = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			data-name='perm_phone_msg_black_24dp (1)'
			width='28'
			height='28'
			viewBox='0 0 28 28'
		>
			<path data-name='Path 15585' d='M0 0h28v28H0z' fill='none' />
			<path
				data-name='Path 15586'
				d='M22.833 17.583a13.254 13.254 0 0 1-4.165-.665 1.191 1.191 0 0 0-1.19.28l-2.567 2.567a17.587 17.587 0 0 1-7.688-7.677L9.79 9.51a1.145 1.145 0 0 0 .292-1.178 13.254 13.254 0 0 1-.665-4.165A1.17 1.17 0 0 0 8.25 3H4.167A1.17 1.17 0 0 0 3 4.167 19.832 19.832 0 0 0 22.833 24 1.17 1.17 0 0 0 24 22.833V18.75a1.17 1.17 0 0 0-1.167-1.167z'
				transform='translate(.5 .5)'
				fill={props.fill}
			/>
			<path
				data-name='Path 15587'
				d='M24 6H14v7h10zm-1.429 2.8L19 11.25 15.429 8.8V7.4L19 9.85l3.571-2.45z'
				transform='translate(0 -2.5)'
				fill={props.fill}
			/>
		</svg>
	);
};

export const Feedback = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='28'
			height='28'
			viewBox='0 0 28 28'
		>
			<path data-name='Path 21' d='M0 0h28v28H0zm0 0h28v28H0z' fill='none' />
			<path
				data-name='Path 22'
				d='M14 7a1.17 1.17 0 0 0-1.167-1.167H6.79l.77-3.71.023-.268A1.354 1.354 0 0 0 7.2.922L6.277 0 .513 5.763A1.756 1.756 0 0 0 0 7v7.583a1.748 1.748 0 0 0 1.75 1.75h7.875a1.76 1.76 0 0 0 1.61-1.062L13.872 9.1A1.7 1.7 0 0 0 14 8.458zm-2.333 1.318L9.24 14H2.333V7.245l2.252-2.252-.665 3.174h7.747zm14.583 3.349h-7.875a1.76 1.76 0 0 0-1.61 1.062L14.128 18.9a1.7 1.7 0 0 0-.128.642V21a1.17 1.17 0 0 0 1.167 1.167h6.043l-.77 3.71-.023.28a1.354 1.354 0 0 0 .385.933l.922.91 5.763-5.763A1.756 1.756 0 0 0 28 21v-7.583a1.748 1.748 0 0 0-1.75-1.75zm-.583 9.088-2.252 2.252.665-3.173h-7.747v-.152L18.76 14h6.907z'
				fill={props.fill}
			/>
		</svg>
	);
};
